import { z } from 'zod';

/** Wspólne typy błędów API — klient mapuje code → reakcja kotka, nigdy surowy tekst. */
export const ErrorCode = z.enum([
  'VALIDATION',
  'UNAUTHORIZED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'RATE_LIMITED',
  'INSUFFICIENT_FUNDS',
  'IDEMPOTENT_REPLAY',
  'VERSION_CONFLICT',
  'MODERATION_REJECTED',
  'SESSION_TAKEN',
  'NOT_IMPLEMENTED',
  'INTERNAL',
]);
export type ErrorCode = z.infer<typeof ErrorCode>;

export const ApiErrorSchema = z.object({
  error: z.object({
    code: ErrorCode,
    retryable: z.boolean(),
  }),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

export const IdempotencyKeySchema = z.string().uuid();
export const UuidSchema = z.string().uuid();
export const PlayerIdSchema = z.string().min(1);
export const AccountIdSchema = z.string().min(1);
export const ProfileIdSchema = z.string().min(1);

/** Token sesji: TYLKO w nagłówku Authorization: Bearer <token> — nigdy w URL/query. */
export const AuthHeaderConvention = {
  header: 'Authorization',
  prefix: 'Bearer ',
  /** Hash w DB = sha256(token); token plaintext tylko u klienta (localStorage). */
  storage: 'localStorage' as const,
  neverInUrl: true as const,
};
